/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type { RouteRecordSingleViewWithChildren } from 'vue-router'

import AppLayout from '@/layouts/AppLayout.vue'
import IngredientsList from '@/pages/ingredients/IngredientsList.vue'
import IngredientsListEdit from '@/pages/ingredients/IngredientsListEdit.vue'

export const ingredientsRouter: RouteRecordSingleViewWithChildren = {
  children: [
    {
      component: IngredientsList,
      meta: {
        title: 'Produkty',
      },
      name: 'IngredientsList',
      path: 'list/',
      props: true,
    },
    {
      component: IngredientsListEdit,
      meta: {
        title: 'Edycja produktu',
      },
      name: 'IngredientsListEdit',
      path: 'edit/:ingredientId(\\d+)',
    },
    {
      component: IngredientsListEdit,
      meta: {
        title: 'Dodawanie produktu',
      },
      name: 'IngredientsListAdd',
      path: 'add/',
    },
  ],
  component: AppLayout,
  meta: {
    auth: true,
  },
  name: 'ingredients',
  path: '/ingredients',
  props: true,
}
